import { Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import LabelBadge from '/@/components/bayer/label-badge';
import { _ } from '/@/locale';
import { getFieldTrialsNetworkEnabled } from '/@/store/field-trial-network/selectors';
import { getInternalProfileEnabled, getUser } from '/@/store/session/selectors';
import { reverse } from '/@/utils/router';

const ProfileHeader = () => {
    const internalProfileEnabled = useSelector(getInternalProfileEnabled);
    const user = useSelector(getUser);
    const fieldTrialNetworkEnabled = useSelector(getFieldTrialsNetworkEnabled);
    const navigate = useNavigate();

    return (
        <Stack>
            <Stack sx={[internalProfileEnabled && { bgcolor: (t) => t.palette.primary.main }]} px={2} py={3}>
                {internalProfileEnabled && (
                    <LabelBadge sx={{ mb: 1, bgcolor: '#CDF1FF' }} size='small' label={_('Perfil interno')} />
                )}
                <Typography color='primary' sx={[internalProfileEnabled && { color: 'white !important' }]} variant='h4'>
                    {_('¡Hola, ') + user.first_name}!
                </Typography>
                <Typography
                    color='primary'
                    sx={[internalProfileEnabled && { color: 'white !important' }]}
                    variant='subtitle1'
                >
                    {_('Gestioná tus lotes con recomendaciones para potenciar el rendimiento de tus cultivos')}
                </Typography>
            </Stack>
            {internalProfileEnabled && fieldTrialNetworkEnabled && (
                <Stack bgcolor={'white'}>
                    <Stack p={2} m={2} bgcolor={'#F5F5F5'}>
                        <Typography
                            color={'primary'}
                            sx={{
                                fontWeight: 'bold',
                            }}
                            variant='subtitle2'
                        >
                            {_('Red de Ensayos')}
                        </Typography>
                        <Stack direction='row'>
                            <Typography color={'primary.mui.inactive'} variant='body2'>
                                {_('Accede a las ubicaciones de todos los ensayos en nuestra red.')}{' '}
                                <Typography
                                    color='secondary'
                                    sx={{
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                        display: 'inline',
                                    }}
                                    variant='body2'
                                    onClick={() => navigate(reverse('FieldTrialNetwork'))}
                                >
                                    {_('Ver ensayos')}
                                </Typography>
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};

export default ProfileHeader;
